import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    GalleryTileDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    container: {
        ...webStyle({
            outlineStyle: "solid",
            cursor: "pointer",
            outlineWidth: 0
        })
    },
    disabledCursor: {
        ...webStyle({
            cursor: "not-allowed"
        })
    },
    surface: {
        justifyContent: "center",
        borderStyle: "dashed",
        alignItems: "center",
        aspectRatio: 1
    },
    presenceItem: {
        flexDirection: "row",
        maxWidth: "100%"
    },
    group: {
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    text: {
        textAlign: "center"
    }
});

export const useStyles = ({
    controlHeights,
    shapeConfigs,
    isDisabled,
    radiuses,
    borders,
    spaces,
    colors
}: GalleryTileDynamicStyleType) => {
    const styles = {
        surface: {
            backgroundColor: isDisabled ? colors.system.state.overlay.disabled.neutral : colors.content.container.raised,
            borderColor: isDisabled ? colors.system.state.border.disabled.neutral : colors.content.border.default,
            ...getCornerStyle({
                radius: radiuses.form,
                shapeConfigs
            }),
            padding: spaces.spacingXs,
            borderWidth: borders.line,
            rowGap: spaces.spacingXs
        } as Mutable<ViewStyle>,
        container: {
            width: controlHeights.large * 3
        } as Mutable<ViewStyle>,
        group: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
